import AddCoupon from "pages/AddCoupon";
import AddDeal from "pages/AddDeal";
import AddPopularSearches from "pages/AddPopularSearches/AddPopularSearches";
import CampaignUpdate from "pages/CampaignsManagement/CampaignUpdate";
import CoupanManagement from "pages/CampaignsManagement/CampaignUpdate/CoupanManagement";
import MSProductCountFullList from "pages/Dashboard/MSProductCountFullList";
import MSProductCountList from "pages/Dashboard/MSProductCountList";
import DealsManagement from "pages/DealsManagement";
import DeliveryFeeManagement from "pages/DeliveryFeeManagement/DeliveryFeeManagement";
import TodaysOrders from "pages/Orders/TodaysOrders";
import PopularSearches from "pages/PopularSearches/PopularSearches";
import ProductStockManagement from "pages/ProductStockManagement/ProductStockManagement";
import { lazy } from "react";

const Login = lazy(() => import("pages/Login"));
const Dashboard = lazy(() => import("pages/Dashboard"));

const AddDeliveryFee = lazy(() => import("pages/AddDeliveryFee"));
const AddStore = lazy(() => import("pages/AddStore"));
const AddProduct = lazy(() => import("pages/AddProduct"));
const AddCampaign = lazy(() => import("pages/AddCampaign"));
const AddCategory = lazy(() => import("pages/AddCategory"));
const AddFaqItems = lazy(() => import("pages/AddFaqItems"));
const AddSubCategory = lazy(() => import("pages/AddSubCategory"));
const AddAccountMang = lazy(() => import("pages/AddAccountMang"));
const AddHomePageBanner = lazy(() => import("pages/AddHomePageBanner"));
const AddZipCode = lazy(() => import("pages/AddZipCodeMang/AddZipCode"));

const RoleManagement = lazy(() => import("pages/RoleManagement"));
const AddRole = lazy(() => import("pages/AddRole"));
const PointUsage = lazy(() => import("pages/PointUsage"));

const Orders = lazy(() => import("pages/Orders"));
const OrderDetails = lazy(() => import("pages/OrderDetails"));
const FaqItems = lazy(() => import("pages/FaqItems"));
const TaxReport = lazy(() => import("pages/TaxReport"));
const ActiveOrders = lazy(() => import("pages/Orders/ActiveOrders"));
const FailedOrders = lazy(() => import("pages/Orders/FailedOrders"));
const StoreZipCodes = lazy(() => import("pages/StoreZipCodes"));
const HomePageBanner = lazy(() => import("pages/HomePageBanner"));
const StoreManagement = lazy(() => import("pages/StoreManagement"));
const AccountMostOrder = lazy(() => import("pages/AccountMostOrder"));
const ZipCodeManagement = lazy(() => import("pages/ZipCodeManagement"));
const ProductManagement = lazy(() => import("pages/ProductManagement"));
const AccountManagement = lazy(() => import("pages/AccountManagement"));
const CategoryManagement = lazy(() => import("pages/CategoryManagement"));
const CampaignsManagement = lazy(() => import("pages/CampaignsManagement"));
const SendPushNotification = lazy(() => import("pages/SendPushNotification"));
const SubCategoryManagement = lazy(() => import("pages/SubCategoryManagement"));
const BrandManagement = lazy(() => import("pages/BrandManagement"));
const AddBrand = lazy(() => import("pages/AddBrand"));
const ProductUpdate = lazy(
  () => import("pages/ProductManagement/ProductUpdate"),
);

const AccountReferralSetting = lazy(
  () => import("pages/AccountReferralSetting"),
);
const ZipcodeRequestManagement = lazy(
  () => import("pages/ZipcodeRequestManagement"),
);

export { default } from "./AppRoutes";

export interface IRoute {
  path: string;
  element: JSX.Element;
}

export const public_routes: IRoute[] = [{ path: "/", element: <Login /> }];

export const private_routes = (role: string): IRoute[] => {
  return [
    ...(["Admin", "Product_Manager", "Dashboard_Viewer"].includes(role)
      ? [
          { path: "/dashboard", element: <Dashboard /> },
          {
            path: "/dashboard/product-analytics",
            element: <MSProductCountFullList />,
          },
        ]
      : []),

    ...(["Admin", "Product_Manager"].includes(role)
      ? [
          { path: "/delivery-fee", element: <DeliveryFeeManagement /> },
          { path: "/add-delivery-fee", element: <AddDeliveryFee /> },
          { path: "/update-delivery-fee/:id", element: <AddDeliveryFee /> },
          { path: "/product-management", element: <ProductManagement /> },
          { path: "/add-product", element: <AddProduct /> },
          { path: "/update-product/:id", element: <ProductUpdate /> },
          { path: "/category-management", element: <CategoryManagement /> },
          { path: "/add-category", element: <AddCategory /> },
          { path: "/update-category/:id", element: <AddCategory /> },

          {
            path: "/subcategory-management",
            element: <SubCategoryManagement />,
          },
          { path: "/add-subcategory", element: <AddSubCategory /> },
          { path: "/update-subcategory/:id", element: <AddSubCategory /> },
          { path: "/popular-searches", element: <PopularSearches /> },
          { path: "/add-search", element: <AddPopularSearches /> },
          { path: "/inventory", element: <ProductStockManagement /> },
          { path: "/update-search/:id", element: <AddPopularSearches /> },
        ]
      : []),

    ...(["Admin"].includes(role)
      ? [
          { path: "/zip-code-management", element: <ZipCodeManagement /> },
          { path: "/add-zipCode", element: <AddZipCode /> },
          { path: "/update-zipcode/:id", element: <AddZipCode /> },
          { path: "/home-page-banner", element: <HomePageBanner /> },
          { path: "/add-homepagebanner", element: <AddHomePageBanner /> },
          {
            path: "/update-homepagebanner/:id",
            element: <AddHomePageBanner />,
          },
          { path: "/faq-items", element: <FaqItems /> },
          { path: "/add-faqItems", element: <AddFaqItems /> },
          { path: "/update-faq/:id", element: <AddFaqItems /> },
          { path: "/role-management", element: <RoleManagement /> },
          { path: "/add-newRole", element: <AddRole /> },
          { path: "/update-role/:id", element: <AddRole /> },
          { path: "/account-management", element: <AccountManagement /> },
          { path: "/add-newAccount", element: <AddAccountMang /> },
          { path: "/update-Account/:id", element: <AddAccountMang /> },
          { path: "/:id/points", element: <PointUsage /> },
          { path: "/accounts-with-most-orders", element: <AccountMostOrder /> },
          {
            path: "/send-push-notification",
            element: <SendPushNotification />,
          },
          { path: "/product-analytics", element: <MSProductCountList /> },
          { path: "/zipcode-requests", element: <ZipcodeRequestManagement /> },

          { path: "/brand-management", element: <BrandManagement /> },
          { path: "/add-brand", element: <AddBrand /> },
          { path: "/update-brand/:id", element: <AddBrand /> },

          { path: "/store-management", element: <StoreManagement /> },
          { path: "/add-store", element: <AddStore /> },
          { path: "/update-store/:id", element: <AddStore /> },

          { path: "/store-zipcodes", element: <StoreZipCodes /> },
          { path: "/campaigns", element: <CampaignsManagement /> },
          { path: "/add-campaign", element: <AddCampaign /> },
          { path: "/update-campaign/:id", element: <CampaignUpdate /> },

          { path: "/active-orders", element: <ActiveOrders /> },
          { path: "/today-orders", element: <TodaysOrders /> },
          { path: "/orders", element: <Orders /> },
          { path: "/orders/:id", element: <OrderDetails /> },
          { path: "/failed-orders", element: <FailedOrders /> },
          { path: "/tax-report", element: <TaxReport /> },
          {
            path: "/account-referral-settings",
            element: <AccountReferralSetting />,
          },

          { path: "/coupon", element: <CoupanManagement /> },
          { path: "/add-coupon", element: <AddCoupon /> },

          // { path: "/inventory", element: <Inventory /> },

          { path: "/deals-management", element: <DealsManagement /> },
          { path: "/add-deal", element: <AddDeal /> },
          { path: "/update-deal/:id", element: <AddDeal /> },
        ]
      : []),
  ];
};
